import { tap } from 'rxjs/operators';
import { IBannerData } from '../interfaces/banner-data.interfaces';
import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { IBannerDataCollection } from '../interfaces/banner-data.interfaces';

@Injectable({
  providedIn: 'root'
})
export class BannerDataService {

  private bannerDataCollection: IBannerDataCollection;

  constructor(private injector: Injector) { }

  loadBannerData() {

    const http = this.injector.get(HttpClient);

    return http.get('assets/config/banner-data.json').pipe(
      tap(data => this.bannerDataCollection = data as IBannerDataCollection)
    ).toPromise();
  }

  bannerDataByKey(key: string): IBannerData {
    return this.bannerDataCollection[key];
  }
}
